module.exports = __webpack_public_path__ + "img/header_phone.a7236440.svg";